<template>
  <div class="p-4 bg-slate-100 flex flex-col h-screen">
    <!-- Menu -->
    <div class="">
      <ul
      class="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400"
      >
      <li class="me-2">
        <button
        type="button"
        @click="setCarte(2)"
        :class="{ active: isActive == 2 }"
        class="inline-flex items-center rounded-t-xl justify-center p-4 border-b-2 border-transparent rounded-t-lg group"
        aria-current="page"
        >
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-sign-merge-right-fill mr-2"
        viewBox="0 0 16 16"
        >
        <path
        d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zM8.75 6v1q.211.451.588.95c.537.716 1.259 1.44 2.016 2.196l-.708.708-.015-.016c-.652-.652-1.33-1.33-1.881-2.015V12h-1.5V6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41z"
        /></svg
        >ETAT GENERAL DES CHAUSSÉES ET INFRASTRUCTURES
      </button>
    </li>
    <li class="me-2">
      <button
      type="button"
      @click="setCarte(3)"
      :class="{ active: isActive == 3 }"
      class="inline-flex items-center rounded-t-xl justify-center p-4 border-b-2 border-transparent rounded-t-lg group"
      >
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-building-fill-exclamation mr-2"
      viewBox="0 0 16 16"
      >
      <path
      d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.256A4.5 4.5 0 0 0 12.5 8a4.5 4.5 0 0 0-3.59 1.787A.5.5 0 0 0 9 9.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .39-.187A4.5 4.5 0 0 0 8.027 12H6.5a.5.5 0 0 0-.5.5V16H3a1 1 0 0 1-1-1zm2 1.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5m3 0v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5m3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zM4 5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5M7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm2.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5M4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"
      />
      <path
      d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0m-3.5-2a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0-.5-.5m0 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
      /></svg
      >CHANTIERS EN COURS
    </button>
  </li>
  
  <!-- <li class="me-2">
    <button
    type="button"
    @click="setCarte(1)"
    :class="{ active: isActive == 1 }"
    class="uppercase rounded-t-xl inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 group"
    >
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    class="bi bi-pin-map-fill mr-2"
    viewBox="0 0 16 16"
    >
    <path
    fill-rule="evenodd"
    d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8z"
    />
    <path
    fill-rule="evenodd"
    d="M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"
    /></svg
    >CHANTIER OBUHA
  </button> 
</li>
-->
</ul>
<div v-if="isLoggedIn" class="absolute top-1 right-2">
  <button @click="logout" class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"> Se Déconnecter </button>
</div>
</div>

<!-- Container -->
<div
class="bg-white h-full rounded-b-xl rounded-r-xl shadow-sm position-relative"
>
<iframe
:src="cartes.carteChausse"
width="100%"
height="100%"
allowfullscreen="true"
key="carte2"
loading="lazy"
:style="style.carteChausse"
class="rounded-b-xl rounded-r-xl rounded-l-xl"
></iframe>


<div v-if="isActive == 3 && !isLoggedIn">
  <login-page />
</div>

<div v-if="isLoggedIn" class="bg-white h-full rounded-b-xl rounded-r-xl shadow-sm position-relative" :style="style.carteChantier">
  <iframe
  :src="cartes.carteChantier"
  width="100%"
  height="100%"
  frameborder="0" 
  allowfullscreen="true"
  key="carte2"
  loading="lazy"
  allow="geolocation" 
  :style="style.carteChantier"
  class="rounded-b-xl rounded-r-xl rounded-l-xl"
  ></iframe>
 
</div>


<div :style="style.carteRoutier" >
  <coming-soon />
</div>

<div
v-if="isActive != 1"
      style="
        position: absolute;
        top: 10px;
        right: 10px;
        width: 100px;
        height: 40px;
        background-color: white;
        z-index: 10;
        border-radius: 5px;
      "
    ></div>
<div class="splashHide"></div>
</div>
</div>
</template>

<script>
import ComingSoon from "@/components/ComingSoon.vue";
import LoginPage from './LoginPage.vue';
export default {
  components: { ComingSoon, LoginPage },
  name: "HomePage",
  data() {
    return {
      isActive: 1,
      isLoggedIn : false,
    };
  },
  watch:{
    "$store.state.localLogin"(e){
      this.isLoggedIn = e;
    }
  },
  mounted() {
    this.setCarte(3);
    if(localStorage.getItem('isLogin') === 'true'){
      this.isLoggedIn = true;
    }
  },
  methods: {
    logout(){
      localStorage.removeItem('isLogin');
      this.isLoggedIn = false;
      this.$store.state.localLogin = false;
    },
    setCarte(id) {
    
      this.isActive = id;
    },
    updateShow() {
      this.showCarte = !this.showCarte;
    },
  },
  computed: {
    isLogin(){
      return localStorage.getItem('isLogin');
      
    },
    cartes() {
      return this.$store.state.cartes;
    },
    style() {
      const resp = {};
      
      if (this.isActive === 1) {
        resp.carteChausse = "display: none; border:0; max-width: 100%;";
        resp.carteRoutier = "display: unset; border:0; max-width: 100%;";
        resp.carteChantier = "display: none; border:0; max-width: 100%;";
      }
      if (this.isActive === 2) {
        resp.carteChausse = "display: unset; border:0; max-width: 100%;";
        resp.carteRoutier = "display: none; border:0; max-width: 100%;";
        resp.carteChantier = "display: none ; border:0; max-width: 100%;";
      }
      if (this.isActive === 3) {
        resp.carteChausse = "display: none ; border:0; max-width: 100%;";
        resp.carteRoutier = "display: none ; border:0; max-width: 100%;";
        resp.carteChantier = "display: unset ; border:0; max-width: 100%;";
      }
      
      return resp;
    },
  },
};
</script>

<style scoped>
li {
  display: inline;
  list-style-type: none;
  padding-right: 20px;
  float: left;
}

.active {
  background-color: white;
}

.position-relative {
  position: relative;
  width: 100%;
}

.splashHide {
  display: block;
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: rgb(255, 255, 255);
  z-index: 9999;
  overflow: hidden;
}
</style>
